import { useMemo } from 'react'

import {
  BookingStatus,
  GetBookingQuery,
  GetSupplierBookingQuery,
  GetUserBookingQuery,
} from 'generated/graphql'

const useIsBookingDisabled = (
  bookingDetails?:
    | GetBookingQuery['booking']
    | GetSupplierBookingQuery['supplierBooking']
    | GetUserBookingQuery['userBooking'],
): boolean => {
  const isBookingDisabled = useMemo(() => {
    return (
      bookingDetails?.isOnHold ||
      bookingDetails?.isArchived ||
      bookingDetails?.isCancelledOrQuoteLost ||
      bookingDetails?.status === BookingStatus.Invoice
    )
  }, [bookingDetails])

  return isBookingDisabled
}

export default useIsBookingDisabled
